import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ALL_ADDRESS_TYPES } from "../../shared/types";

interface Props {
	name: string;
	label: string;
}

export const AddressTypeSelect: FC<Props> = ({ name, label }) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField
			options={ALL_ADDRESS_TYPES.map((x) => ({ label: t(x), value: x }))}
			getLabel={(x) => x.label}
			getValue={(x) => x.value}
			name={name}
			label={label}
			clearable={false}
		/>
	);
};
